// External ordering (Flipdish) — customers order & pay here.
export const ORDER_ONLINE_URL = "https://sugaspice.flipdish.menu/order";
